import GanttCard from './GanttCard'

export default GanttCard
